<template>
    <div>
        <div class="modal hide fade" id="modalGetPriceList" tabindex="-1" role="dialog" aria-labelledby="modalGetPriceList" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Price List</h4>
                        <span>{{ state }}</span>
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button> -->
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label for="group_no" class="col-sm-3 col-form-label text-left">Group</label>
                                    <div class="col-sm-9">
                                        <select v-model="pList.group_id" id="group_id" class="form-control">
                                            <option v-for="g in groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="quantity" class="col-sm-3 col-form-label text-left">Quantity</label>
                                    <div class="col-sm-9">
                                        <input class="form-control" type="text" id="quantity" v-model="pList.quantity"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="price" class="col-sm-3 col-form-label text-left">Price</label>
                                    <div class="col-sm-9">
                                        <input v-model.lazy="pList.price" v-money="money" class="form-control">
                                    </div>
                                </div>
                                <div class="form-group row">
                                  <label for="uom_id" class="col-sm-3 col-form-label text-left">Unit</label>
                                  <div class="col-sm-9">
                                    <select v-model="pList.uom_id" class="form-control">
                                      <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="form-group row">
                                    <label for="amount" class="col-sm-3 col-form-label text-left">Validity</label>
                                    <div class="col-sm-3">
                                      <datetime v-model="pList.start_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-hard-primary" data-dismiss="modal" @click="cancel()">Cancel</button>
                      <button type="button" class="btn btn-soft-primary" data-dismiss="modal" @click="save()">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductModalPrice',
  props: ['product', 'id', 'state'],
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      groupList: state => state.priceLists.priceListGroup,
      uomList: state => state.uom.uomList
    }),
    pList: function () {
      var obj
      var index = this.product.priceList.find(d => d.id === this.id)
      if (index) {
        return index
      } else {
        obj = {
          id: null,
          group_id: null,
          product_no: null,
          quantity: null,
          price: null,
          uom_id: null,
          start_date: null,
          end_date: null
        }
        return obj
      }
    }
  },
  methods: {
    save () {
      var group = this.groupList.find(d => d.id === this.pList.group_id)
      if (this.pList.uom_id === null) {
        var uid = this.product.uom_id
      } else {
        uid = this.pList.uom_id
      }
      this.pList.uom_id = uid
      this.pList.group = group.name
      this.pList.state = this.state
      console.log(this.pList)
    },
    cancel () {
      if (this.state === 'create') {
        var index = this.product.priceList.findIndex(d => d.id === this.id)

        this.product.priceList.splice(index, 1)
      }
    }
  }
}
</script>
